import { FormDataEntries, TryParseJSONObject } from "@lib/utils/Utils";
import { ZodError, ZodIssueBase, ZodCustomIssue, z, ZodTypeAny, custom } from "zod";

 /**
 * Validations a form against a zod schema. Creates elements for the any zod errors
 * @param form the html form to validate
 * @param schema the zod schema to use to validate
 * @param event the event object (form submit, button click, htmx custom event etc.)
 * @param customClassList an error of css class names to attach to the error objects for custom styling
 */
export const GenericZodSchemaFormValidation = <Schema extends ZodTypeAny>(
    form: HTMLFormElement, 
    schema: Schema, 
    event: Event, 
    customClassList: string[] = []) : boolean => 
{
    const validationErrors = document.querySelectorAll('.field-validation-error');
    validationErrors.forEach(item => item.remove());

    const data = Object.fromEntries(new FormData(form));

    const isValidated = ValidateFormDataAndAddErrors<typeof schema> (data, schema, customClassList);
    
    if (!isValidated) {
        event?.preventDefault();
        event?.stopPropagation();
        return false;
    }

    return true;
}

export const ValidateFormDataAndAddErrors = <Schema extends ZodTypeAny>(data: FormDataEntries, schema: Schema, customClassList: string[] = []) => {
    try {
        schema.parse(data);     
        return true;
    }
    catch(error) {
        ZodFormValidationDisplay(JSON.parse(error), customClassList);
        return false;
    }
}

// [TODO]: should we make this type safe?
export function ZodFormValidationDisplay(errors: any, customClassList: string[] = []) 
{
    //const o = TryParseJSONObject(errors);
    if (errors !== undefined && typeof errors == 'string') {
        alert(errors);
        return;
    }

    if (errors !== undefined && typeof errors !== 'object') {
        alert('Error processing request');
        return;
    }

    errors.forEach(item => {
        item.path.forEach((obj: string, index: number) => {                
            if (item.params?.skipFirst !== undefined && index == 0)
            {
                return;
            }
            AddValidationElement(obj, item.message ?? "", customClassList);
        });
    });
}

function AddValidationElement(path: string, message: string, customClassList: string[] = [])
{
    const element = document.querySelector('[name="' + path + '"]') as HTMLElement;
    const validationSpan = document.createElement('span') as HTMLSpanElement;
    
    validationSpan.classList.add("field-validation-error", ...customClassList);
    validationSpan.innerText = message ?? "required";      

    if (element) {
        element.parentElement?.appendChild(validationSpan);        
    }
    else {
        alert("[Schema-Error]: " + path + " - no element matching on schema.");
    }
}

export function loader()
{
    const element = document.createElement('div');
    element.innerHTML = `
        <div class="my-indicator ml-25 p-100 text--align-center d-inline-block">
            <div style="text-align: center;" class="loader"></div>
        </div>
    `;
    return element;
}